import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { defaultJobDetailsFormValues, jobDetailsSchema, type JobDetailsFormValues } from './JobDetailsStep.schema';

export function useJobDetailsStepForm(defaultValues?: Partial<JobDetailsFormValues>) {
    return useForm({
        defaultValues: { ...defaultJobDetailsFormValues, ...defaultValues },
        resolver: zodResolver(jobDetailsSchema),
        mode: 'all',
    });
}
